export default {"src":"/evde-internet/_next/static/media/datatransfer.03a3d598.svg","height":48,"width":48};